import React from 'react';
import styled from 'styled-components';
import TermsSelect from 'modules/configure/terms/TermsSelect';
import TermsTooltip from 'modules/configure/terms/TermsTooltip';
import { Props } from 'modules/addon/VisualAddonPage';
import ChooseTier from 'modules/configure/common/ChooseTier';
import { Dimensions, Font } from 'components/visuals';
import t from 'modules/i18n/intl';
import { checkFeatureGate, FeatureFlags } from 'util/statsig';

const Wrapper = styled.div`
  display: flex;
`;

const Header = styled.h4`
  font-family: ${Font.displayFamily};
  font-size: 20px;
  font-weight: 500;
  margin-bottom: ${Dimensions.units(1)}px;
`;

const Manual = ({ data, manual, events, terms }: Props) => {
  const isLimitDCMultiYearContractsFFON = checkFeatureGate(
    FeatureFlags.CART_LIMIT_DC_MULTI_YEAR_CONTRACTS,
  );
  const isDataCenter = data.deploymentOption === 'datacenter';

  return (
    <Wrapper>
      <div>
        <Header>{t('addon.manual.user-tier')}</Header>
        <ChooseTier
          tiers={data.tiers}
          selected={manual.tier || data.tiers[0]}
          onChange={events.onTierSelect}
          showPrices={!data.isSubscription}
          currency={data.currency}
        />
      </div>
      <div>
        <Header>
          {data.isSubscription ? t('addon.subscription-term') : t('addon.maintenance-period')}
          &nbsp;
          <TermsTooltip subscription={data.isSubscription} />
        </Header>
        <TermsSelect
          options={
            isLimitDCMultiYearContractsFFON && isDataCenter
              ? data.manualTerms.filter((term) => term.months !== 24)
              : data.manualTerms
          }
          selected={terms.manual || data?.manualTerms[0]}
          onChange={(tier) => events.onTermChange('manual', tier)}
          currency={data.currency}
        />
      </div>
    </Wrapper>
  );
};

export default Manual;
